import _ from 'lodash';

export const getSetting = <T>(field: string): T | undefined => {
    return _.get(window, `globalSettings.${field}`);
};
